import { AdvancedListWViewMore } from '../components/inventory/advanced-list-w-view-more.vue';
Vue.component('advanced-list-w-view-more', AdvancedListWViewMore);